import createTheme from '@material-ui/core/styles/createTheme'
import defaultTheme from './themes/defaultTheme';

export const theme = createTheme({
  overrides: {
    MuiInputLabel: {
      root: {
        transform: 'translate(0, 1.5px) scale(0.75) !important',
        transformOrigin: 'top left'
      }
    },
    MuiInput: {
      root: {
        '&:before': { display: 'none' },
        '&:after': { display: 'none' },
        '& + p': {
          marginTop: '-5px !important'
        },
        '&$error': {
          '& input:not(:focus), & textarea': {
            borderBottom: '2px solid #F44336 !important'
          }
        }
      }
    },
    MuiFormControl: {
      root: {
        outline: 'none',
        marginTop: '0 !important'
      }
    }
  },
  typography: {
    fontFamily: 'Open sans, sans-serif',
    fontSize: 14,
    subtitle1: {
      color: defaultTheme.defaultTheme.gray_palette.dark1,
      fontSize: 16,
      fontWeight: 600
    },
    subtitle2: {
      color: defaultTheme.defaultTheme.main_palette.dark,
      fontSize: 16,
      fontWeight: 600
    },
    body1: {
      color: defaultTheme.defaultTheme.gray_palette.dark1,
      fontSize: 14,
      fontWeight: 400
    },
    body2: {
      color: defaultTheme.defaultTheme.main_palette.dark,
      fontSize: 14,
      fontWeight: 400
    },
    caption: {
      color: defaultTheme.defaultTheme.gray_palette.dark1,
      fontSize: 12,
      fontWeight: 400
    }
  },
  palette: {
    primary: {
      light: '#636672',
      main: '#393C47',
      dark: '#131620',
      contrastText: '#fff'
    },
    secondary: {
      light: '#4ec485',
      main: '#009358',
      dark: '#00642e',
      contrastText: '#fff'
    }
  },
});
